const cartSelectors = {
    all: state => state.cart.items,
    byId: id => state => state.cart.items.find(item => item.id === id),
}

export default cartSelectors
